import { render, staticRenderFns } from "./DownloadSummary.vue?vue&type=template&id=8a7b5900"
import script from "./DownloadSummary.vue?vue&type=script&lang=js"
export * from "./DownloadSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports